import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Stack } from '@alfa-bank/site-stack';
import { SidePanelDesktop as SidePanel } from '@alfalab/core-components-side-panel/desktop';

import type { TSidePanelDesktop, ISidePanelDepsDesktop } from '../models';

import { SidePanelDesktop as Component } from './side-panel';

export const SidePanelDesktop = createWidget<ISidePanelDepsDesktop, TSidePanelDesktop>({
    SidePanel,
    Stack,
})(Component);
